<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">设备入库</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button size="small" type="primary" @click="addClick">新增设备入库</el-button>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="设备入库单" name="1"></el-tab-pane>
            <el-tab-pane label="已撤销" name="0"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="id" label="订单编号" ></el-table-column>
            <el-table-column  prop="status" label="订单状态" >
                <template slot-scope="scope">
                    <div>{{scope.row.status == 1?'创建成功':'已撤销'}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="createdAt" label="创建时间" v-if="activeName == 1">
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="createdAt" label="撤销时间" v-if="activeName == 2">
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="createName" v-if="activeName == 1" label="创建人" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="updateName" v-if="activeName == 2" label="撤销人" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="total"  label="入库设备数量" >
                <template slot-scope="scope">
                    <div>{{scope.row.total}}台</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="type" v-if="activeName == 1" label="入库方式" >
                <template slot-scope="scope">
                    <div>{{scope.row.type == 1?'新增入库':'退换货入库'}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                <el-button size="mini" type="text" v-if="scope.row.canRevoke == true" v-preventReClick @click="revokeClick(scope.$index, scope.row)">撤销</el-button>
                <el-button size="mini" type="text" v-preventReClick @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="addDeviceForm" :rules="rules" ref="addDeviceForm">
                <el-form-item label="款式">
                    <el-select v-model="styleId" @change="styleChange" placeholder="请选择">
                        <el-option
                        v-for="item in styleList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备sn码">
                    <el-input size="small" v-model="addDeviceForm.machineId" style="width:230px" auto-complete="off" placeholder="请输入设备sn码"></el-input>
                    <el-button size="small" type="primary" :loading="loading" class="title" @click="addDeviceClick()">添加</el-button>
                </el-form-item>
                <el-form-item label="已添加sn码">
                    <div v-for=" (item , index ) in machineIdList" :key="index" style="display:flex;">
                        <div>{{ item.sn }} {{item.styleName}}</div><div style="margin-left: 20px;color:red;cursor:pointer;" @click="deleteClick(index)">删除</div>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="addDeviceSunmit()">保存</el-button>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="入库单详情" :visible.sync="detailsFlag" width="40%" @click="closeDialog">
            <el-descriptions class="margin-top" title="创建入库单信息" :column="3" :size="size" border>
                <el-descriptions-item label="订单编号">{{StorageOrder.id}}</el-descriptions-item>
                <el-descriptions-item label="操作人">{{ StorageOrder.createName }}</el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ StorageOrder.createdAt|timestampToTime }}</el-descriptions-item>
                <el-descriptions-item label="入库设备数量">{{ StorageOrder.total }}</el-descriptions-item>
                <el-descriptions-item label="入库方式">{{ StorageOrder.type == 1?'新增入库':'退换货入库'}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" v-if="StorageOrder.status == 1" style="margin-top: 20px;" title="入库详情" :column="3" :size="size" border>
                <el-descriptions-item label="设备详情">
                    <div style="display:flex">
                        <div style="text-align:center;width:200px;border:1px solid #eee;line-height:40px">设备sn码</div>
                        <div style="text-align:center;width:200px;border:1px solid #eee;line-height:40px">款式</div>
                    </div>
                    <div v-for=" item in machineList" :key="item">
                        <div style="display:flex">
                            <div style="text-align:center;width:200px;border:1px solid #eee;line-height:40px">{{ item.machineId }}</div>
                            <div style="text-align:center;width:200px;border:1px solid #eee;line-height:40px">{{item.styleName}}</div>
                        </div>
                    </div>
                </el-descriptions-item>
            </el-descriptions>

            <el-descriptions v-if="StorageOrder.updateName != undefined" class="margin-top" style="margin-top: 20px;" title="撤销入库单信息" :column="2" :size="size" border>
                <el-descriptions-item label="操作人">{{StorageOrder.updateName}}</el-descriptions-item>
                <el-descriptions-item label="撤销时间">{{ StorageOrder.updatedAt|timestampToTime }}</el-descriptions-item>
                <el-descriptions-item label="备注">{{StorageOrder.remark}}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>
        <!-- 绑定机器 -->
        <el-dialog title="撤销入库单" :visible.sync="revokeFlag" width="25%" @click="closeDialog">
                <el-form :inline="true" :model="formInline" class="user-search">
                    <el-form-item label="备注">
                        <el-input size="small" v-model="remark" style="width:250px"  placeholder="备注"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="revokeFlag = false">取消</el-button>
                    <el-button size="small" type="primary" :loading="loading" class="title" @click="revokeSubmit()">保存</el-button>
                </div>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../components/Pagination'
import { loadStorageOrderList , createStorageOrder , 
    getStorageOrderDetail , revokeStorageOrder , 
    checkMachineId , styleList} from '../../api/userMG'
export default {
    data(){
        return{
            styleName:'',
            styleId:'',
            styleList:'',
            revokeFlag:false,
            machineList:[],
            StorageOrder:{},
            addDeviceForm:{
                machineId:''
            },
            machineIdList:[],
            id:'',
            bindingFlag:false,
            activeName:"1",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
            },
            machineData:[],
            listData: [{
                url:'https://thirdwx.qlogo.cn/mmopen/vi_32/8kKUTuTsoibsLSHPAXfUAjX7zPssdyWk8CorQicic8gzHHuu517RcdXEhKFtIqvNyR0APLeyPiaqn6iaGfWzJp4Er5Q/132',
                sort:'1',
                status:0,
            }], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            remark:''
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
        this.styleQuery()
    },
    methods:{
        styleChange(e){ 
            console.log(e)
            for(let item of this.styleList){
                if(e == item.id){
                    this.styleName = item.name
                }
            }
        },
        styleQuery(){
            styleList().then(res=>{
                this.styleList = res.data
            })
        },
        handleClick(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        addDeviceSunmit(){
            console.log(this.machineIdList)
            if(this.machineIdList.length == 0){
                this.$message.error('请添加设备sn码')
            }else{
                createStorageOrder(this.machineIdList).then(res=>{
                    if(res.success){
                        this.$message.success('添加成功')
                        this.machineIdList = []
                        this.editFormVisible = false
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }
        },
        revokeSubmit(){
            if(this.remark == ''){
                this.$message.error("请填写备注")
            }else{
                revokeStorageOrder({
                    id:this.id,
                    remark:this.remark
                }).then(res=>{
                    if(res.success){
                        this.remark = ''
                        this.$message.success('撤销成功')
                        this.revokeFlag = false
                        this.getdata()
                    }else {
                        this.$message.error(res.messages)
                    }
                })
            }
        },  
        revokeClick(index , row){
            this.remark = ''
            this.revokeFlag = true
            this.id = row.id
        },
        addDeviceClick(){
            if(this.addDeviceForm.machineId == ''){
                this.$message.error('设备sn码不能为空')
            }else if(this.styleId == ''){
                this.$message.error('请选择款式')
            }else{
                let pushFlag = false
                for(let item of this.machineIdList){
                    if(item.sn == this.addDeviceForm.machineId){
                        pushFlag = true
                    }
                }
                if(pushFlag == true){
                    this.$message.error('该设备sn码已添加')
                }else{
                    checkMachineId({
                        machineId:this.addDeviceForm.machineId,
                        
                    }).then(res=>{
                        if(res.success){
                            if(res.isOk == 0){
                                this.machineIdList.unshift({
                                    sn:this.addDeviceForm.machineId,
                                    styleId:this.styleId,
                                    styleName:this.styleName
                                })
                                this.addDeviceForm.machineId = ''
                            }else if(res.isOk == 1) {
                                this.$message.error('该设备sn码重复')
                            }else {
                                this.$message.error('该设备已出库')
                            }
                        }else {
                            this.$message.error(res.messages)
                        }
                    })
                }
            }
        },
        deleteClick(index){
            this.machineIdList.splice(index , 1)
        },
        handleEdit(index , row){
            getStorageOrderDetail({
                id:row.id
            }).then(res=>{
                if(res.success){
                    this.detailsFlag = true
                    this.StorageOrder = res.StorageOrder
                    this.machineList = res.machineList
                    // this.editForm = row
                }else {
                    this.$message.error(res.messages)
                }
            })
            
        },
        addClick(){
            this.editFormVisible = true
            this.addDeviceForm.machineId = ''
            this.machineIdList = []
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            loadStorageOrderList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                status:this.activeName
            }).then(res=>{
                this.listData = res.pageInfo.list
                this.pageparm.total = res.pageInfo.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/equipmentManagement/EquipmentWarehousing.vue